import type { KambiBetOffer, KambiEvent, KambiGroup, KambiLiveData } from '@mobi/api-types/kambi'
import { simpleFetch } from '@mobi/utils/fetch/simpleFetch'

export function getEventsForGroupId(groupId: number) {
  return simpleFetch<{ events: KambiEvent[] }>(
    `${window._kc.apiOfferingBaseUrl}event/group/${groupId}`
  )
}

export function getUpcomingEventsForAllSports() {
  return simpleFetch<{ events: KambiEvent[]; group: KambiGroup }>(
    `${window._kc.apiOfferingBaseUrl}event/livecalendar`
  )
}

export function getEventsBySportTermKey(sport: string) {
  return simpleFetch<{
    events: { event: KambiEvent; betOffers: KambiBetOffer[]; liveData: KambiLiveData }[]
  }>(
    `${window._kc.apiOfferingBaseUrl}listView/${sport}?lang=en_AU&market=AU&includeParticipants=false&useCombined=true&useCombinedLive=true`
  )
}
